export const INVALID_SMART_QUOTES = /\u2018|\u2019|\u201c|\u201d/gi;
export const INVALID_SMART_AND_CJK_PUNCTUATION = /[\u2014]|\u2026|[\u3000-\u303f]|[\u30fb-\u30ff]/gi;
export const INVALID_SLUG_CHAR_MATCHER = /[^a-zA-Z0-9\-_/\s.\u00AE-\ud7ff]/gi;